import { translateMain } from '../../../../helpers'
import { SHORTHANDS } from '../models/context-menu.constants'
import { ContextMenuItem } from '../models/context-menu.types'
import { createIcon } from './icon-resolver'

export function createExportItem(gridApi) {
  return {
    name: translateMain('lbl_exp_excel'),
    action: () => {
      if (gridApi) {
        gridApi.exportDataAsExcel()
      }
    },
    icon: createIcon('export'),
    permissionKey: 'EXPORT_DATA',
  }
}

export function createBufferItem(gridApi) {
  return {
    name: translateMain('lbl_exp_clip'),
    action: () => {
      gridApi.selectAll()
      gridApi.copySelectedRowsToClipboard(true)
      gridApi.deselectAll()
      console.log('text copied successfully')
    },
    icon: createIcon('buffer'),
    permissionKey: 'EXPORT_DATA',
  }
}

export function createRowIdentifier(name) {
  return {
    name,
    disabled: true,
    cssClasses: ['lk-row-identifier'],
    tooltip: name,
    type: 'title',
    order: 0,
  }
}

export function setDefaultItems(item: ContextMenuItem & string) {
  const { api } = this

  if (typeof item === 'string' && item === SHORTHANDS.EXPORT) {
    return [createExportItem(api), createBufferItem(api)]
  } else if (item.type === 'title') {
    return createRowIdentifier(item.name)
  }

  return item
}
